import { ImageCompression } from 'jspdf';
import { BarcodeType } from '../types/barcode.type';
import { CombinedPaperTypeAndOrientation } from '../types/combined-paper-type-and-orientation.type';
import { PaperOrientation } from '../types/paper-orientation.type';

export class FormValues {
  public barcodeType: BarcodeType;
  public rangeStart: number;
  public rangeEnd: number;
  public additionalText: string;
  public paperType: CombinedPaperTypeAndOrientation;
  public paperLeftMargin: number;
  public paperTopMargin: number;
  public paperRightMargin: number;
  public paperBottomMargin: number;
  public labelWidth: number;
  public labelHeight: number;
  public labelGutterWidth: number;
  public labelGutterHeight: number;
  public numberOfColumns: number;
  public renderingQuality: number;
  public compressionRate: ImageCompression;
  public barcodeTemplatePrefix: string;
  public barcodeTemplateSuffix: string;

  static blank() {
    const values = new FormValues();

    values.barcodeType = 'CODE128';
    values.rangeStart = 0;
    values.rangeEnd = 0;
    values.additionalText = '';
    values.paperType = 'A4_PORTRAIT';
    values.paperLeftMargin = 0;
    values.paperTopMargin = 0;
    values.paperRightMargin = 0;
    values.paperBottomMargin = 0;
    values.labelWidth = 0;
    values.labelHeight = 0;
    values.labelGutterWidth = 0;
    values.labelGutterHeight = 0;
    values.numberOfColumns = 0;
    values.renderingQuality = 0.1;
    values.compressionRate = 'FAST';
    values.barcodeTemplatePrefix = '';
    values.barcodeTemplateSuffix = '';

    return values;
  }

  toObject() {
    return {
      barcodeType: this.barcodeType,
      rangeStart: this.rangeStart,
      rangeEnd: this.rangeEnd,
      additionalText: this.additionalText,
      paperType: this.paperType,
      paperLeftMargin: this.paperLeftMargin,
      paperTopMargin: this.paperTopMargin,
      paperRightMargin: this.paperRightMargin,
      paperBottomMargin: this.paperBottomMargin,
      labelWidth: this.labelWidth,
      labelHeight: this.labelHeight,
      labelGutterWidth: this.labelGutterWidth,
      labelGutterHeight: this.labelGutterHeight,
      numberOfColumns: this.numberOfColumns,
      renderingQuality: this.renderingQuality,
      compressionRate: this.compressionRate,
      barcodeTemplatePrefix: this.barcodeTemplatePrefix,
      barcodeTemplateSuffix: this.barcodeTemplateSuffix,
    };
  }
}
